import { Outlet, Navigate, useNavigate } from "react-router-dom";
import { usePortal } from "@/context/PortalContext";
import { SignOut, UserCircle } from "@phosphor-icons/react";
import ForceChangePinKaryawan from "@/components/ForceChangePinKaryawan";

export default function PortalLayout() {
  const { karyawan, loading, logout } = usePortal();
  const nav = useNavigate();

  if (loading) return <div className="h-screen flex items-center justify-center text-slate-500">Memuat...</div>;
  if (!karyawan) return <Navigate to="/karyawan/login" replace />;

  const doLogout = async () => {
    await logout();
    nav("/karyawan/login");
  };

  return (
    <div className="min-h-screen bg-[#F4F7F9]" data-testid="portal-layout">
      <header className="bg-[#00558F] text-white px-4 py-3 flex items-center justify-between sticky top-0 z-30 shadow-md">
        <div className="flex items-center gap-2.5 min-w-0">
          <img src="/logo-gema.png" alt="GEMA" className="w-9 h-9 rounded-lg object-cover shrink-0" data-testid="portal-logo"/>
          <div className="min-w-0">
            <div className="font-heading font-bold text-sm leading-tight truncate" data-testid="portal-karyawan-nama">{karyawan.nama}</div>
            <div className="text-[10px] opacity-80 tracking-wider truncate">
              {karyawan.nik} · {(karyawan.divisi || "").toUpperCase()}
            </div>
          </div>
        </div>
        <button
          data-testid="portal-logout"
          onClick={doLogout}
          className="flex items-center gap-1 text-xs px-3 py-1.5 rounded bg-white/10 hover:bg-white/20 transition-colors shrink-0"
        >
          <SignOut size={14}/> Keluar
        </button>
      </header>
      <main className="p-4 pb-10 max-w-3xl mx-auto">
        <Outlet />
      </main>
      <ForceChangePinKaryawan/>
    </div>
  );
}
